import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { pt } from 'vuetify/lib/locale'
import { en } from 'vuetify/lib/locale'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { pt, en },
    current: 'pt'
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#057A3D',
        secondary: '#EAF7EF',
        dark: '#111827',
        gray: '#F7FAF7',
        lightGray: '#E4E9E2',
        offWhite: '#F5F7F5',
        black: '#101828',
        mediumBlack: '#1F2937',
        mediumGray: '#6B7280',
        darkGray: '#7A827B',
        important: '#FB3A04',
        lightImportant: '#FEF2F2',
        white: '#FFFFFF',
        accent: '#0EA35B',
        error: '#f59a9a',
        yellow:'#FFC400',
        blue:'#2563EB',
        green:'#0EA35B',
        red:'#E53935',

      }
    }
  }
})
